// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const {
  defaultReviver,
  keyedReviver
} = require('client-v2/common/state/record-reviver')

class EnvironmentRecord extends Immutable.Record({
  baseUrl: String(),
  browser: Immutable.Map(),
  buildNumber: String(),
  csrfToken: String(),
  deeplinkUrls: Immutable.Map(),
  extensionInstalled: Boolean(),
  iconsUrl: String(),
  nativeEmbedded: Boolean(),
  openInAppDismissed: Boolean()
}) {
  // No methods
}

EnvironmentRecord.reviver = keyedReviver(EnvironmentRecord, {
  browser: defaultReviver,
  deeplinkUrls: defaultReviver
})

module.exports = EnvironmentRecord
